// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusBar__statusBar-c019f3 {
  --sb-color: var(--chat-bubble-text-secondary);
  display: flex;
  align-items: center;
  color: var(--sb-color);
  gap: 8px;
}

.StatusBar__fixed-color-d56aaf {
  --sb-color: var(--addition-50);
}

.StatusBar__edited-d71d35 {
  margin-inline-end: 8px;
  fill: var(--base-70);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/StatusBar/styles.m.css"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,sBAAA;EACA,oBAAA;AACF","sourcesContent":[".statusBar {\n  --sb-color: var(--chat-bubble-text-secondary);\n  display: flex;\n  align-items: center;\n  color: var(--sb-color);\n  gap: 8px;\n}\n\n.fixed-color {\n  --sb-color: var(--addition-50);\n}\n\n.edited {\n  margin-inline-end: 8px;\n  fill: var(--base-70);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusBar": `StatusBar__statusBar-c019f3`,
	"fixed-color": `StatusBar__fixed-color-d56aaf`,
	"fixedColor": `StatusBar__fixed-color-d56aaf`,
	"edited": `StatusBar__edited-d71d35`
};
module.exports = ___CSS_LOADER_EXPORT___;
